export default __webpack_public_path__ + "static/media/Number_2_selected.2d9046f2.svg";